import { render, staticRenderFns } from "./ConfirmAppointment.vue?vue&type=template&id=142585a7&scoped=true&"
import script from "./ConfirmAppointment.vue?vue&type=script&lang=js&"
export * from "./ConfirmAppointment.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAppointment.vue?vue&type=style&index=0&id=142585a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142585a7",
  null
  
)

export default component.exports